const currencyFormatters: {
  [key: string]: Intl.NumberFormat;
} = {};

const GetCurrencyFormatter = (currencyCode: string) => {
  let currencyFormatter = currencyFormatters[currencyCode];

  if (!currencyFormatter) {
    currencyFormatter = new Intl.NumberFormat("en-GB", {
      style: "currency",
      currency: currencyCode,
      maximumFractionDigits: 2,
      minimumFractionDigits: 2,
      currencyDisplay: "symbol",
    });
    currencyFormatters[currencyCode] = currencyFormatter;
  }
  return currencyFormatter;
};

export default function FormatCurrency(
  value: number,
  currencyCode = "AUD",
  countryCode = "AU"
) {
  try {
    const currencyFormatter = GetCurrencyFormatter(currencyCode);
    let formattedValue = currencyFormatter.format(value).replace(".00", "");
    if (currencyCode === "AUD" && countryCode === "AU") {
      formattedValue = formattedValue.replace(/^A[$]/gi, "$");
    }
    return formattedValue;
  } catch {
    console.error("failed to format currency");
    return value.toString();
  }
}
